import {
  combine,
  withRef,
  withEffect,
  withState,
  withCallbacks,
} from 'react-hooks-combine'

import PageSizeComponent from './component'

export const PageSize = combine(
  withRef('pageSizeControlRef'),

  withState('opened', 'open', false),

  withEffect(({ open, pageSizeControlRef }) => {
    const listener = ({ target }) => {
      if (!pageSizeControlRef.current.contains(target)) {
        open(false)
      }
    }

    document.addEventListener('click', listener)

    return () => {
      document.removeEventListener('click', listener)
    }
  }, []),

  withCallbacks(
    {
      onTriggerMenu:
        ({ open }) =>
        () => {
          open((opened) => !opened)
        },

      onRequestPageSizeChange: {
        deps: ['pageSizeOptions', 'onPageSizeChange'],
        func:
          ({ open }, { onPageSizeChange }) =>
          ({ target }) => {
            const size = Number(target.dataset.size)
            onPageSizeChange(size)
            open(false)
          },
      },
    },
    []
  )
)(PageSizeComponent)
